import React, { useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { Tab, Nav } from "react-bootstrap";
import Gallery from "./Gallery";
import Attractions from "./Attractions";
import { GET_ALL_EVENTS } from "../../query/GetEvents";
import { hasuraClient } from "../../apolloClient";
import moment from "moment";
import AllEvent from "../Event/EventTab";
import { GET_IMAGE_EVENT } from "../../query/Gallery";
import { GET_ALL_ATTRACTIONS } from "../../query/getAllAttractions";

const CouncilTab = () => {
  const [date, setDate] = useState("");
  const [allEventImagesData, setAllEventImagesData] = useState([]);

  const [
    getAllEvents,
    {
      data: eventData,
      refetch: refetchEvents,
      loading: allEventLoading,
      error: allEventError,
    },
  ] = useLazyQuery(GET_ALL_EVENTS, {
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
      currentDateTime: date,
    },
  });

  const { data: attractionData } = useQuery(GET_ALL_ATTRACTIONS, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
    variables: {
      council_profile_id: localStorage.getItem("profile_id"),
    },
  });

  const [
    getImageGallery,
    { data: allEventImages, loading: allEventImagesLoading },
  ] = useLazyQuery(GET_IMAGE_EVENT, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  useEffect(() => {
    if (allEventImages?.business_council_image_gallery_view?.length) {
      let arr = [...allEventImagesData];
      for (
        let i = 0;
        i < allEventImages?.business_council_image_gallery_view?.length;
        i++
      ) {
        arr.push(allEventImages?.business_council_image_gallery_view[i]);
      }
      setAllEventImagesData(arr);
    }
  }, [allEventImages]);
  useEffect(() => {
    getImageGallery({
      variables: {
        limit: 6,
        offset: 0,
      },
    });
    setDate(moment().toISOString());
    getAllEvents();
  }, []);
  return (
    <div className="counciltab">
      <div className="council-tab-inner">
        <Tab.Container id="left-tabs-example" defaultActiveKey="Events">
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="Events">
                <span className="tab-name">Events</span>
                <span className="count">
                  {eventData?.all_count?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Attractions">
                <span className="tab-name">Attractions</span>
                <span className="count">
                  {attractionData?.attractions?.length}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Gallery">
                <span className="tab-name">Gallery</span>
                <span className="count">
                  {
                    allEventImages
                      ?.business_council_image_gallery_view_aggregate?.aggregate
                      ?.count
                  }
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="Events">
              <div className="post-block" style={{ padding: 0 }}>
                <div className="tab-content" style={{ paddingTop: 0 }}>
                  <AllEvent
                    noEditDelete
                    data={eventData ? eventData?.all_event : null}
                    refetch={refetchEvents}
                    loading={allEventLoading}
                    error={allEventError}
                  />
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="Attractions">
              <Attractions attractionData={attractionData} />
            </Tab.Pane>
            <Tab.Pane eventKey="Gallery">
              <Gallery
                count={
                  allEventImages?.business_council_image_gallery_view_aggregate
                    ?.aggregate?.count
                }
                data={allEventImagesData}
                searchQuery={getImageGallery}
                loading={allEventImagesLoading}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default CouncilTab;
